import { createContext, ReactNode, useContext, useState } from "react";

const MobileFilterModalContext = createContext({
  modalActive: false,
  setModalActive: (_modalActive: boolean) => {},
});

export const MobileFilterModalProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [modalActive, setModalActive] = useState(false);

  return (
    <MobileFilterModalContext.Provider
      value={{
        modalActive,
        setModalActive,
      }}
    >
      {children}
    </MobileFilterModalContext.Provider>
  );
};

export const useMobileFilterModalContext = () =>
  useContext(MobileFilterModalContext);
